import { useState } from 'react';
import Header from '../../components/base/Header';
import Footer from '../../components/base/Footer';

interface Plant {
  id: number;
  name: string;
  scientificName: string;
  category: string;
  image: string;
  description: string;
  difficulty: string;
  bloomSeason: string;
  careGuide: {
    light: string;
    water: string;
    temperature: string;
    humidity: string;
    fertilizer: string;
    repotting: string;
    tips: string[];
    warnings: string[];
  };
}

const plantsData: Plant[] = [
  // 胡蝶蘭の種類
  {
    id: 1,
    name: '白花胡蝶蘭',
    scientificName: 'Phalaenopsis amabilis',
    category: 'orchid',
    image: 'https://public.readdy.ai/ai/img_res/e23946d72174c9aabd158251c0bfa296.jpg',
    description: '最も人気の高い胡蝶蘭で、純白の美しい花を咲かせます。お祝いの贈り物として定番の品種です。',
    difficulty: '中級',
    bloomSeason: '春〜初夏',
    careGuide: {
      light: '明るい日陰を好みます。直射日光は避け、レースカーテン越しの光が理想的です。',
      water: '水苔が乾いてから与えます。週1〜2回程度、根元にたっぷりと。受け皿の水は必ず捨てましょう。',
      temperature: '18〜28℃が適温。冬は15℃以下にならないよう注意してください。',
      humidity: '60〜70%の高湿度を好みます。加湿器や霧吹きで湿度を保ちましょう。',
      fertilizer: '春〜秋に月1回、薄めた液体肥料を与えます。冬は肥料を控えめに。',
      repotting: '2〜3年に1回、花が終わった後に植え替えを行います。',
      tips: [
        '花が終わったら花茎を根元から切り取ります',
        '葉の表面を定期的に濡れタオルで拭いてあげましょう',
        '風通しの良い場所に置くことが重要です'
      ],
      warnings: [
        '水のやりすぎは根腐れの原因になります',
        '急激な温度変化は避けてください',
        'エアコンの風が直接当たる場所は避けましょう'
      ]
    }
  },
  {
    id: 2,
    name: 'ピンク胡蝶蘭',
    scientificName: 'Phalaenopsis schilleriana',
    category: 'orchid',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20pink%20phalaenopsis%20orchid%20flowers%20in%20bloom%2C%20soft%20pink%20petals%20with%20elegant%20form%2C%20romantic%20atmosphere%2C%20detailed%20botanical%20photography%2C%20clean%20background%2C%20luxury%20flower%20arrangement%20style&width=300&height=300&seq=pink-orchid-1&orientation=squarish',
    description: '優雅なピンク色の花を咲かせる美しい胡蝶蘭。女性への贈り物として人気が高い品種です。',
    difficulty: '中級',
    bloomSeason: '春〜初夏',
    careGuide: {
      light: '明るい日陰を好みます。朝の柔らかい日光は良いですが、強い直射日光は避けてください。',
      water: '水苔の表面が乾いたら水やりのタイミング。根元にゆっくりと水を注ぎます。',
      temperature: '20〜25℃が最適。夜間は少し涼しくても大丈夫です。',
      humidity: '65〜75%の湿度を維持。乾燥する季節は特に注意が必要です。',
      fertilizer: '成長期には2週間に1回、薄めた蘭専用肥料を与えます。',
      repotting: '根が鉢からはみ出してきたら植え替えのサインです。',
      tips: [
        '花色を美しく保つため、適度な温度差が必要です',
        '葉の色で健康状態をチェックしましょう',
        '支柱で花茎を支えてあげると美しく咲きます'
      ],
      warnings: [
        '過湿は病気の原因になります',
        '葉に水滴が残らないよう注意してください',
        '冷暖房の風が直接当たらないようにしましょう'
      ]
    }
  },
  {
    id: 3,
    name: '黄色胡蝶蘭',
    scientificName: 'Phalaenopsis Golden Peoker',
    category: 'orchid',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20yellow%20phalaenopsis%20orchid%20flowers%20in%20bloom%2C%20bright%20golden%20yellow%20petals%2C%20cheerful%20and%20vibrant%2C%20detailed%20botanical%20photography%2C%20clean%20background%2C%20luxury%20flower%20arrangement%20style&width=300&height=300&seq=yellow-orchid-1&orientation=squarish',
    description: '明るい黄色の花が特徴的な胡蝶蘭。開店祝いや新築祝いなど、お祝い事に人気の品種です。',
    difficulty: '中級',
    bloomSeason: '春〜夏',
    careGuide: {
      light: '明るい間接光を好みます。窓際のレースカーテン越しが最適です。',
      water: '根の状態を確認しながら水やり。透明な鉢なら根の色で判断できます。',
      temperature: '18〜26℃を維持。昼夜の温度差があると花つきが良くなります。',
      humidity: '60〜70%の湿度。霧吹きで葉の周りの湿度を上げましょう。',
      fertilizer: '春から秋にかけて月2回、希釈した液体肥料を与えます。',
      repotting: '2年に1回程度、春に植え替えを行います。',
      tips: [
        '花色を鮮やかに保つため、適切な光量が重要です',
        '新芽が出てきたら成長期のサインです',
        '花が長持ちするよう、涼しい場所に置きましょう'
      ],
      warnings: [
        '水やり後は受け皿の水を必ず捨ててください',
        '葉焼けを防ぐため、強い日光は避けましょう',
        '根腐れしやすいので水の与えすぎに注意'
      ]
    }
  },
  {
    id: 4,
    name: '紫胡蝶蘭',
    scientificName: 'Phalaenopsis Purple Gem',
    category: 'orchid',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20purple%20phalaenopsis%20orchid%20flowers%20in%20bloom%2C%20deep%20purple%20petals%20with%20elegant%20form%2C%20sophisticated%20atmosphere%2C%20detailed%20botanical%20photography%2C%20clean%20background%2C%20luxury%20flower%20arrangement%20style&width=300&height=300&seq=purple-orchid-1&orientation=squarish',
    description: '神秘的な紫色の花を咲かせる希少な胡蝶蘭。上品で洗練された印象を与える特別な品種です。',
    difficulty: '上級',
    bloomSeason: '春〜初夏',
    careGuide: {
      light: '明るい日陰を好みます。色素を保つため、適度な光が必要です。',
      water: '水苔が完全に乾く前に水やり。紫色の品種は水分管理が重要です。',
      temperature: '20〜24℃の安定した温度を保ちます。',
      humidity: '70〜80%の高湿度を維持してください。',
      fertilizer: '月1回、蘭専用の肥料を薄めて与えます。',
      repotting: '2〜3年に1回、慎重に植え替えを行います。',
      tips: [
        '紫色を美しく保つため、温度管理が重要です',
        '花色が薄くなったら光量を調整しましょう',
        '特に丁寧な管理が必要な品種です'
      ],
      warnings: [
        '温度変化に敏感です',
        '過度の乾燥は花色に影響します',
        '病気になりやすいので清潔に保ちましょう'
      ]
    }
  },
  {
    id: 5,
    name: 'ミニ胡蝶蘭',
    scientificName: 'Phalaenopsis Mini Mark',
    category: 'orchid',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20mini%20phalaenopsis%20orchid%20flowers%2C%20small%20compact%20blooms%20with%20delicate%20petals%2C%20charming%20miniature%20size%2C%20detailed%20botanical%20photography%2C%20clean%20background%2C%20cute%20flower%20arrangement%20style&width=300&height=300&seq=mini-orchid-1&orientation=squarish',
    description: '手のひらサイズの可愛らしい胡蝶蘭。場所を取らず、初心者にも育てやすい人気の品種です。',
    difficulty: '初級',
    bloomSeason: '通年',
    careGuide: {
      light: '明るい窓際を好みます。小さいので光の調整がしやすいです。',
      water: '週1回程度、少量の水を与えます。小さな鉢なので乾きやすいです。',
      temperature: '18〜25℃で管理。室内の温度で十分です。',
      humidity: '50〜60%の湿度。霧吹きで調整しやすいサイズです。',
      fertilizer: '月1回、薄めた液体肥料を少量与えます。',
      repotting: '1〜2年に1回、小さな鉢に植え替えます。',
      tips: [
        '小さいので管理しやすく初心者向けです',
        '複数並べて飾ると可愛らしいです',
        '花が終わっても葉を楽しめます'
      ],
      warnings: [
        '小さいので乾燥しやすいです',
        '肥料の与えすぎに注意',
        '風通しを良くしてください'
      ]
    }
  },
  {
    id: 6,
    name: '斑入り胡蝶蘭',
    scientificName: 'Phalaenopsis Variegata',
    category: 'orchid',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20variegated%20phalaenopsis%20orchid%20with%20striped%20petals%2C%20white%20flowers%20with%20pink%20or%20purple%20stripes%2C%20unique%20pattern%2C%20detailed%20botanical%20photography%2C%20clean%20background%2C%20special%20variety%20flower&width=300&height=300&seq=variegated-orchid-1&orientation=squarish',
    description: '花弁に美しい斑模様が入る珍しい胡蝶蘭。コレクターに人気の希少品種です。',
    difficulty: '上級',
    bloomSeason: '春',
    careGuide: {
      light: '明るい日陰を好みます。斑模様を美しく保つため光量調整が重要です。',
      water: '水苔が乾いてから与えます。斑入り品種は水分に敏感です。',
      temperature: '20〜25℃の安定した温度を保ちます。',
      humidity: '65〜75%の湿度を維持してください。',
      fertilizer: '月1回、薄めた肥料を慎重に与えます。',
      repotting: '2〜3年に1回、専門的な知識が必要です。',
      tips: [
        '斑模様を美しく保つため、環境管理が重要です',
        '希少品種なので大切に育てましょう',
        '専門書を参考にした管理をお勧めします'
      ],
      warnings: [
        '環境変化に非常に敏感です',
        '病気になりやすいので注意が必要',
        '初心者には難しい品種です'
      ]
    }
  },

  // チランジアの種類
  {
    id: 7,
    name: 'ウスネオイデス',
    scientificName: 'Tillandsia usneoides',
    category: 'tillandsia',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20tillandsia%20usneoides%20spanish%20moss%20hanging%20air%20plant%2C%20silvery%20gray%20cascading%20strands%2C%20ethereal%20appearance%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background&width=300&height=300&seq=usneoides-1&orientation=squarish',
    description: 'スパニッシュモスとも呼ばれる垂れ下がるタイプのエアプランツ。銀灰色の美しい姿が魅力的です。',
    difficulty: '初級',
    bloomSeason: '不定期',
    careGuide: {
      light: '明るい日陰を好みます。直射日光は避け、風通しの良い場所に吊るしてください。',
      water: '週2〜3回、霧吹きで全体を湿らせます。夏は毎日、冬は控えめに。',
      temperature: '15〜30℃の範囲で管理。寒さにはやや弱いです。',
      humidity: '50〜60%の湿度。乾燥しすぎないよう注意しましょう。',
      fertilizer: '月1回程度、薄めた液体肥料を霧吹きで与えます。',
      repotting: '土に植える必要はありません。吊るして育てます。',
      tips: [
        '風通しが最も重要です',
        '水やり後はしっかり乾燥させましょう',
        '成長すると自然に分かれて増えます'
      ],
      warnings: [
        '水が溜まったままだと腐りやすいです',
        '密閉された場所では育ちません',
        '過度の乾燥は枯れる原因になります'
      ]
    }
  },
  {
    id: 8,
    name: 'イオナンタ',
    scientificName: 'Tillandsia ionantha',
    category: 'tillandsia',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20tillandsia%20ionantha%20air%20plant%20with%20compact%20silver-green%20rosette%20leaves%20turning%20bright%20red%20when%20blooming%2C%20small%20spiky%20succulent-like%20form%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting&width=300&height=300&seq=ionantha-correct&orientation=squarish',
    description: '小型で育てやすいエアプランツの代表種。開花時には葉が美しく赤く染まります。',
    difficulty: '初級',
    bloomSeason: '春〜夏',
    careGuide: {
      light: '明るい間接光を好みます。室内の窓際が適しています。',
      water: '週2回程度、霧吹きで葉全体を湿らせます。夏は頻度を増やしてください。',
      temperature: '10〜30℃で管理。比較的温度変化に強い品種です。',
      humidity: '40〜60%の湿度。エアコンの効いた部屋でも育ちます。',
      fertilizer: '2週間に1回、薄めた液体肥料を霧吹きで与えます。',
      repotting: '土は不要。流木や石に着生させることもできます。',
      tips: [
        '開花前に葉が赤くなるのは正常です',
        '子株ができたら分けて増やせます',
        '水やり後は逆さにして水を切りましょう'
      ],
      warnings: [
        '水が葉の間に溜まらないよう注意',
        '冬は水やりを控えめにしてください',
        '急激な環境変化は避けましょう'
      ]
    }
  },
  {
    id: 9,
    name: 'キセログラフィカ',
    scientificName: 'Tillandsia xerographica',
    category: 'tillandsia',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20tillandsia%20xerographica%20large%20air%20plant%20with%20silvery%20curled%20leaves%2C%20majestic%20rosette%20form%2C%20king%20of%20air%20plants%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting&width=300&height=300&seq=xerographica-1&orientation=squarish',
    description: 'エアプランツの王様と呼ばれる大型種。銀色の美しい葉がカールする姿が印象的です。',
    difficulty: '中級',
    bloomSeason: '数年に1回',
    careGuide: {
      light: '明るい日陰を好みます。強い光は葉焼けの原因になります。',
      water: '週1回程度、たっぷりと霧吹きで水を与えます。冬は控えめに管理してください。',
      temperature: '15〜25℃が適温。寒さにはやや弱いです。',
      humidity: '30〜50%の湿度。他のエアプランツより乾燥を好みます。',
      fertilizer: '月1回、薄めた液体肥料を与えます。与えすぎは禁物です。',
      repotting: '大型になるため、十分なスペースを確保してください。',
      tips: [
        '成長は非常にゆっくりです',
        '葉のカールが美しさのポイントです',
        '風通しの良い場所で管理しましょう'
      ],
      warnings: [
        '過湿は根腐れの原因になります',
        '葉の中心に水が溜まらないよう注意',
        '急激な温度変化は避けてください'
      ]
    }
  },
  {
    id: 10,
    name: 'カプトメデューサエ',
    scientificName: 'Tillandsia caput-medusae',
    category: 'tillandsia',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20tillandsia%20caput-medusae%20air%20plant%20with%20twisted%20snake-like%20leaves%2C%20unique%20medusa%20head%20form%2C%20exotic%20appearance%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting&width=300&height=300&seq=caput-medusae-1&orientation=squarish',
    description: 'メデューサの頭のような独特な形が特徴的なエアプランツ。くねくねとした葉が魅力的です。',
    difficulty: '中級',
    bloomSeason: '春〜夏',
    careGuide: {
      light: '明るい間接光を好みます。直射日光は避けてください。',
      water: '週2回程度、霧吹きで全体を湿らせます。葉の間に水が溜まらないよう注意。',
      temperature: '15〜28℃で管理。温度変化に比較的強いです。',
      humidity: '50〜70%の湿度を保ちます。',
      fertilizer: '月1回、薄めた液体肥料を霧吹きで与えます。',
      repotting: '着生植物なので土は不要です。',
      tips: [
        '独特な形を楽しむ観賞用植物です',
        '葉の動きが面白い品種です',
        'インテリアとしても人気があります'
      ],
      warnings: [
        '葉の間に水が溜まりやすいので注意',
        '風通しを良くしてください',
        '過度の乾燥は葉が縮む原因になります'
      ]
    }
  },
  {
    id: 11,
    name: 'ブルボーサ',
    scientificName: 'Tillandsia bulbosa',
    category: 'tillandsia',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20tillandsia%20bulbosa%20air%20plant%20with%20bulbous%20base%20and%20thin%20curly%20leaves%2C%20unique%20onion-like%20form%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting&width=300&height=300&seq=bulbosa-1&orientation=squarish',
    description: '球根のような膨らんだ基部が特徴的なエアプランツ。細い葉がカールする美しい品種です。',
    difficulty: '中級',
    bloomSeason: '春',
    careGuide: {
      light: '明るい日陰を好みます。強い光は避けてください。',
      water: '週2〜3回、霧吹きで水を与えます。基部に水が溜まらないよう注意。',
      temperature: '18〜26℃で管理。温暖な環境を好みます。',
      humidity: '60〜70%の湿度を維持します。',
      fertilizer: '月1回、薄めた液体肥料を与えます。',
      repotting: '着生植物なので植え替えは不要です。',
      tips: [
        '基部の膨らみが健康のバロメーターです',
        '細い葉が美しくカールします',
        '湿度を好む品種です'
      ],
      warnings: [
        '基部に水が溜まると腐りやすいです',
        '乾燥しすぎると葉が枯れます',
        '風通しを良くしてください'
      ]
    }
  },
  {
    id: 12,
    name: 'ストリクタ',
    scientificName: 'Tillandsia stricta',
    category: 'tillandsia',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20tillandsia%20stricta%20air%20plant%20with%20compact%20rosette%20and%20pink%20flower%20spike%2C%20silver-green%20leaves%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting&width=300&height=300&seq=stricta-1&orientation=squarish',
    description: 'コンパクトなロゼット型のエアプランツ。ピンクの美しい花を咲かせる人気品種です。',
    difficulty: '初級',
    bloomSeason: '春〜夏',
    careGuide: {
      light: '明るい間接光を好みます。室内栽培に適しています。',
      water: '週2回程度、霧吹きで全体を湿らせます。',
      temperature: '15〜28℃で管理。温度変化に比較的強いです。',
      humidity: '50〜70%の湿度を保ちます。',
      fertilizer: '2週間に1回、薄めた液体肥料を霧吹きで与えます。',
      repotting: '土は不要。流木や石に着生させることができます。',
      tips: [
        '初心者にも育てやすい品種です',
        'ピンクの花が美しく咲きます',
        '子株で増やすことができます'
      ],
      warnings: [
        '水やり後はしっかり乾燥させてください',
        '密閉された場所は避けましょう',
        '冬は水やりを控えめにしてください'
      ]
    }
  },

  // シクラメンの種類
  {
    id: 13,
    name: 'ガーデンシクラメン',
    scientificName: 'Cyclamen persicum',
    category: 'cyclamen',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20garden%20cyclamen%20flowers%20in%20pink%20and%20white%20colors%2C%20heart-shaped%20leaves%20with%20silver%20patterns%2C%20winter%20flowering%20plant%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting&width=300&height=300&seq=garden-cyclamen-1&orientation=squarish',
    description: '寒さに強く、屋外でも育てられる改良品種。冬の庭を彩る人気の花です。',
    difficulty: '初級',
    bloomSeason: '秋〜春',
    careGuide: {
      light: '明るい日陰を好みます。夏は日陰、冬は日向に置きましょう。',
      water: '土の表面が乾いたら、株元にたっぷりと水を与えます。葉や花に水をかけないよう注意。',
      temperature: '5〜15℃が適温。暑さに弱いので夏は涼しい場所で管理。',
      humidity: '適度な湿度を保ちますが、過湿は避けてください。',
      fertilizer: '開花期間中は月2回、薄めた液体肥料を与えます。',
      repotting: '夏の休眠期に植え替えを行います。',
      tips: [
        '花がらはこまめに摘み取りましょう',
        '夏は休眠するので水やりを控えます',
        '寒さに当てると花つきが良くなります'
      ],
      warnings: [
        '葉や花に水をかけると病気の原因になります',
        '高温多湿は苦手です',
        '球根を深く植えすぎないよう注意'
      ]
    }
  },
  {
    id: 14,
    name: '原種シクラメン',
    scientificName: 'Cyclamen coum',
    category: 'cyclamen',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20wild%20cyclamen%20coum%20flowers%2C%20small%20delicate%20pink%20blooms%2C%20heart-shaped%20leaves%2C%20natural%20woodland%20setting%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting&width=300&height=300&seq=wild-cyclamen-1&orientation=squarish',
    description: '野生種のシクラメンで、小さくて可憐な花を咲かせます。自然な美しさが魅力です。',
    difficulty: '中級',
    bloomSeason: '冬〜早春',
    careGuide: {
      light: '半日陰を好みます。強い直射日光は避けてください。',
      water: '成長期は適度に水を与え、休眠期は乾燥気味に管理します。',
      temperature: '0〜20℃で管理。寒さには非常に強いです。',
      humidity: '自然な湿度で十分です。過湿は避けましょう。',
      fertilizer: '春と秋に緩効性肥料を少量与えます。',
      repotting: '3〜4年に1回、休眠期に植え替えます。',
      tips: [
        '自然な環境を再現することが大切です',
        '種から育てることも可能です',
        '群生させると美しい景観になります'
      ],
      warnings: [
        '夏の高温多湿は苦手です',
        '球根を傷つけないよう注意',
        '急激な環境変化は避けてください'
      ]
    }
  },
  {
    id: 15,
    name: 'ミニシクラメン',
    scientificName: 'Cyclamen persicum mini',
    category: 'cyclamen',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20mini%20cyclamen%20flowers%20in%20various%20colors%2C%20compact%20size%20with%20small%20delicate%20blooms%2C%20perfect%20for%20indoor%20decoration%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting&width=300&height=300&seq=mini-cyclamen-1&orientation=squarish',
    description: '手のひらサイズの小さなシクラメン。室内装飾に最適で、様々な色の品種があります。',
    difficulty: '初級',
    bloomSeason: '秋〜春',
    careGuide: {
      light: '明るい窓際を好みます。レースカーテン越しの光が理想的です。',
      water: '底面給水が最適。受け皿に水を入れて下から吸わせます。',
      temperature: '10〜18℃が適温。暖房の効きすぎた部屋は避けてください。',
      humidity: '適度な湿度を保ちますが、葉に水滴がつかないよう注意。',
      fertilizer: '開花期間中は2週間に1回、薄めた液体肥料を与えます。',
      repotting: '年1回、夏の休眠期に植え替えを行います。',
      tips: [
        'コンパクトなので室内装飾に最適です',
        '花色のバリエーションが豊富です',
        '涼しい場所で長く花を楽しめます'
      ],
      warnings: [
        '暖房の効いた部屋では花が早く終わります',
        '水のやりすぎは根腐れの原因になります',
        '葉に水をかけないよう注意してください'
      ]
    }
  },
  {
    id: 16,
    name: 'フリンジ咲きシクラメン',
    scientificName: 'Cyclamen persicum fringed',
    category: 'cyclamen',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20fringed%20cyclamen%20flowers%20with%20ruffled%20petal%20edges%2C%20decorative%20frilly%20blooms%2C%20elegant%20winter%20flowering%20plant%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting&width=300&height=300&seq=fringed-cyclamen-1&orientation=squarish',
    description: '花弁の縁がフリル状になった華やかなシクラメン。装飾的で美しい品種です。',
    difficulty: '中級',
    bloomSeason: '秋〜春',
    careGuide: {
      light: '明るい間接光を好みます。強い光は花弁を傷める可能性があります。',
      water: '土の表面が乾いたら株元に水を与えます。花に水がかからないよう注意。',
      temperature: '12〜18℃が適温。涼しい環境を好みます。',
      humidity: '適度な湿度を保ちますが、花弁に水滴がつかないよう注意。',
      fertilizer: '開花期間中は月2回、薄めた液体肥料を与えます。',
      repotting: '夏の休眠期に慎重に植え替えを行います。',
      tips: [
        'フリル状の花弁が特徴的で美しいです',
        '花がらはこまめに摘み取りましょう',
        '涼しい場所で管理すると長く楽しめます'
      ],
      warnings: [
        '花弁が繊細なので取り扱いに注意',
        '高温は花の形を崩す原因になります',
        '水やりは慎重に行ってください'
      ]
    }
  },

  // 季節の花
  {
    id: 17,
    name: '桜（ソメイヨシノ）',
    scientificName: 'Prunus × yedoensis',
    category: 'seasonal',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20yoshino%20cherry%20blossoms%20in%20full%20bloom%2C%20delicate%20pale%20pink%20petals%2C%20spring%20season%20atmosphere%2C%20traditional%20Japanese%20scenery%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting&width=300&height=300&seq=yoshino-cherry-1&orientation=squarish',
    description: '日本の春を代表する美しい桜。淡いピンクの花が一斉に咲く姿は圧巻です。',
    difficulty: '中級',
    bloomSeason: '春',
    careGuide: {
      light: '日当たりの良い場所を好みます。十分な日光が開花に必要です。',
      water: '植え付け後は定期的に水やりを行います。根付いたら自然の雨で十分です。',
      temperature: '寒さに強く、日本の気候に適応しています。',
      humidity: '自然の湿度で十分です。',
      fertilizer: '春と秋に有機肥料を与えます。',
      repotting: '庭木として植える場合は植え替えは不要です。',
      tips: [
        '剪定は花後すぐに行います',
        '病害虫の予防が重要です',
        '開花時期は短いので大切に楽しみましょう'
      ],
      warnings: [
        '病気になりやすいので注意が必要',
        '強い剪定は避けてください',
        '根を傷つけないよう注意'
      ]
    }
  },
  {
    id: 18,
    name: 'アジサイ',
    scientificName: 'Hydrangea macrophylla',
    category: 'seasonal',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20blue%20hydrangea%20flowers%20in%20rainy%20season%2C%20large%20clustered%20blooms%20with%20changing%20colors%2C%20Japanese%20garden%20atmosphere%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting&width=300&height=300&seq=hydrangea-1&orientation=squarish',
    description: '梅雨の時期を彩る代表的な花。土壌のpHによって花色が変化する興味深い植物です。',
    difficulty: '初級',
    bloomSeason: '初夏',
    careGuide: {
      light: '半日陰を好みます。強い直射日光は避けてください。',
      water: '水を好む植物です。土が乾かないよう定期的に水やりを行います。',
      temperature: '日本の気候に適応しており、特別な温度管理は不要です。',
      humidity: '高湿度を好みます。梅雨時期に最も美しく咲きます。',
      fertilizer: '春と秋に緩効性肥料を与えます。',
      repotting: '鉢植えの場合は2〜3年に1回植え替えます。',
      tips: [
        '土壌のpHで花色が変わります',
        '剪定は花後すぐに行います',
        '水切れに注意してください'
      ],
      warnings: [
        '水不足は花を傷める原因になります',
        '強い日光は葉焼けの原因になります',
        '冬の寒風は避けてください'
      ]
    }
  },
  {
    id: 19,
    name: 'コスモス',
    scientificName: 'Cosmos bipinnatus',
    category: 'seasonal',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20pink%20cosmos%20flowers%20swaying%20in%20autumn%20breeze%2C%20delicate%20petals%20with%20graceful%20form%2C%20autumn%20field%20atmosphere%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting&width=300&height=300&seq=cosmos-1&orientation=squarish',
    description: '秋の風に揺れる可憐な花。種から簡単に育てることができる人気の一年草です。',
    difficulty: '初級',
    bloomSeason: '秋',
    careGuide: {
      light: '日当たりの良い場所を好みます。十分な日光で美しく咲きます。',
      water: '乾燥に強い植物です。水のやりすぎに注意してください。',
      temperature: '涼しい気候を好みます。秋の気候が最適です。',
      humidity: '自然の湿度で十分です。',
      fertilizer: '肥料は控えめに。多すぎると葉ばかり茂ります。',
      repotting: '一年草なので植え替えは不要です。',
      tips: [
        '種から簡単に育てられます',
        '摘心すると枝分かれして花数が増えます',
        '切り花としても楽しめます'
      ],
      warnings: [
        '肥料の与えすぎは花つきを悪くします',
        '強風で倒れやすいので支柱が必要',
        '霜に弱いので注意してください'
      ]
    }
  },
  {
    id: 20,
    name: 'ポインセチア',
    scientificName: 'Euphorbia pulcherrima',
    category: 'seasonal',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20red%20poinsettia%20flowers%20with%20vibrant%20bracts%2C%20Christmas%20season%20atmosphere%2C%20festive%20winter%20plant%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting&width=300&height=300&seq=poinsettia-1&orientation=squarish',
    description: 'クリスマスの定番植物。赤い苞葉が美しく、冬の室内を華やかに彩ります。',
    difficulty: '中級',
    bloomSeason: '冬',
    careGuide: {
      light: '明るい場所を好みますが、短日処理が必要です。',
      water: '土の表面が乾いたら水を与えます。過湿は避けてください。',
      temperature: '15〜25℃が適温。寒さに弱いので室内で管理します。',
      humidity: '適度な湿度を保ちます。乾燥しすぎないよう注意。',
      fertilizer: '成長期に月1回、薄めた液体肥料を与えます。',
      repotting: '春に植え替えを行います。',
      tips: [
        '短日処理で赤い苞葉を作ります',
        '温度管理が重要です',
        '来年も楽しむには専門的な管理が必要'
      ],
      warnings: [
        '寒さに非常に弱いです',
        '樹液に触れるとかぶれることがあります',
        '急激な環境変化は避けてください'
      ]
    }
  },

  // 盆栽
  {
    id: 21,
    name: '松の盆栽',
    scientificName: 'Pinus parviflora',
    category: 'bonsai',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20pine%20bonsai%20tree%20with%20elegant%20needle%20foliage%2C%20traditional%20Japanese%20bonsai%20style%2C%20artistic%20miniature%20tree%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting%2C%20zen%20garden%20atmosphere&width=300&height=300&seq=pine-bonsai-1&orientation=squarish',
    description: '盆栽の王様とも呼ばれる松の盆栽。風格ある姿と美しい針葉が魅力的です。',
    difficulty: '上級',
    bloomSeason: '通年（葉を楽しむ）',
    careGuide: {
      light: '日当たりの良い場所を好みます。室外での管理が基本です。',
      water: '土の表面が乾いたら水を与えます。水はけの良い土を使用します。',
      temperature: '寒さに強く、四季を通じて屋外で管理できます。',
      humidity: '自然の湿度で十分です。',
      fertilizer: '春と秋に固形肥料を与えます。',
      repotting: '2〜3年に1回、春に植え替えを行います。',
      tips: [
        '針金かけで樹形を整えます',
        '芽摘みで成長をコントロールします',
        '長期間の育成が必要です'
      ],
      warnings: [
        '室内での長期管理は避けてください',
        '急激な環境変化は避けましょう',
        '専門的な技術が必要です'
      ]
    }
  },
  {
    id: 22,
    name: 'もみじの盆栽',
    scientificName: 'Acer palmatum',
    category: 'bonsai',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20maple%20bonsai%20tree%20with%20delicate%20leaves%2C%20autumn%20red%20foliage%2C%20traditional%20Japanese%20bonsai%20style%2C%20artistic%20miniature%20tree%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting&width=300&height=300&seq=maple-bonsai-1&orientation=squarish',
    description: '四季の変化を楽しめるもみじの盆栽。特に秋の紅葉が美しい人気の樹種です。',
    difficulty: '中級',
    bloomSeason: '通年（紅葉は秋）',
    careGuide: {
      light: '明るい日陰を好みます。強い直射日光は葉焼けの原因になります。',
      water: '水を好む植物です。土が乾かないよう注意してください。',
      temperature: '寒さに強く、四季を通じて屋外で管理できます。',
      humidity: '適度な湿度を保ちます。',
      fertilizer: '春と秋に緩効性肥料を与えます。',
      repotting: '1〜2年に1回、春に植え替えを行います。',
      tips: [
        '葉刈りで小さな葉を作ります',
        '秋の紅葉が最大の魅力です',
        '繊細な枝ぶりを楽しめます'
      ],
      warnings: [
        '強い日光は葉を傷めます',
        '水切れに注意してください',
        '風通しを良くしてください'
      ]
    }
  },
  {
    id: 23,
    name: '桜の盆栽',
    scientificName: 'Prunus serrulata',
    category: 'bonsai',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20cherry%20blossom%20bonsai%20tree%20with%20pink%20flowers%2C%20miniature%20sakura%20in%20bloom%2C%20traditional%20Japanese%20bonsai%20style%2C%20artistic%20flowering%20tree%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting&width=300&height=300&seq=cherry-bonsai-1&orientation=squarish',
    description: '春に美しい花を咲かせる桜の盆栽。小さな鉢の中で桜の美しさを楽しめます。',
    difficulty: '中級',
    bloomSeason: '春',
    careGuide: {
      light: '日当たりの良い場所を好みます。開花には十分な日光が必要です。',
      water: '水を好む植物です。特に開花期は水切れに注意してください。',
      temperature: '寒さに強く、冬の寒さが開花に必要です。',
      humidity: '自然の湿度で十分です。',
      fertilizer: '花後と秋に肥料を与えます。',
      repotting: '2年に1回、花後に植え替えを行います。',
      tips: [
        '花後の剪定が重要です',
        '寒さに当てることで花芽ができます',
        '開花期間は短いので大切に楽しみましょう'
      ],
      warnings: [
        '病気になりやすいので注意',
        '強い剪定は避けてください',
        '水切れは花を傷めます'
      ]
    }
  },
  {
    id: 24,
    name: 'ツツジの盆栽',
    scientificName: 'Rhododendron indicum',
    category: 'bonsai',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20azalea%20bonsai%20tree%20with%20colorful%20flowers%2C%20miniature%20flowering%20shrub%2C%20traditional%20Japanese%20bonsai%20style%2C%20artistic%20blooming%20tree%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting&width=300&height=300&seq=azalea-bonsai-1&orientation=squarish',
    description: '色鮮やかな花を咲かせるツツジの盆栽。コンパクトで花付きが良い人気の樹種です。',
    difficulty: '初級',
    bloomSeason: '春〜初夏',
    careGuide: {
      light: '明るい日陰を好みます。強い直射日光は避けてください。',
      water: '水を好む植物です。土が乾かないよう注意してください。',
      temperature: '寒さに比較的強く、屋外で管理できます。',
      humidity: '適度な湿度を保ちます。',
      fertilizer: '花後と秋に酸性肥料を与えます。',
      repotting: '1〜2年に1回、花後に植え替えを行います。',
      tips: [
        '酸性土壌を好みます',
        '花がらはこまめに摘み取りましょう',
        '比較的育てやすい樹種です'
      ],
      warnings: [
        'アルカリ性土壌は避けてください',
        '水切れに注意してください',
        '強い日光は葉を傷めます'
      ]
    }
  },

  // 観葉植物（既存）
  {
    id: 25,
    name: 'モンステラ',
    scientificName: 'Monstera deliciosa',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20monstera%20deliciosa%20houseplant%20with%20large%20split%20leaves%2C%20tropical%20indoor%20plant%20with%20distinctive%20fenestrations%2C%20modern%20home%20decor%20setting%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20green%20foliage%20background&width=300&height=300&seq=monstera-1&orientation=squarish',
    description: '大きな切れ込みの入った葉が特徴的な人気の観葉植物。インテリアグリーンとして非常に人気が高く、育てやすい品種です。',
    difficulty: '初級',
    bloomSeason: '通年（葉を楽しむ）',
    careGuide: {
      light: '明るい日陰を好みます。直射日光は避け、レースカーテン越しの光が最適です。',
      water: '土の表面が乾いたらたっぷりと水を与えます。冬は控えめに。',
      temperature: '20〜30℃が適温。寒さにはやや弱いので冬は注意が必要です。',
      humidity: '50〜60%の湿度を保ちます。乾燥する季節は霧吹きで葉水を与えましょう。',
      fertilizer: '春〜秋に月1回、薄めた液体肥料を与えます。',
      repotting: '1〜2年に1回、春に植え替えを行います。',
      tips: [
        '葉の切れ込みは成長とともに深くなります',
        '支柱を立てると大きく育ちます',
        '葉水を定期的に与えると美しく保てます'
      ],
      warnings: [
        '寒さに弱いので冬は室内で管理',
        '水のやりすぎは根腐れの原因になります',
        '葉が大きくなるので十分なスペースが必要'
      ]
    }
  },
  {
    id: 26,
    name: 'フィカス・ウンベラータ',
    scientificName: 'Ficus umbellata',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20ficus%20umbellata%20houseplant%20with%20large%20heart-shaped%20leaves%2C%20elegant%20indoor%20tree%20in%20modern%20living%20room%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20stylish%20home%20decor%20setting&width=300&height=300&seq=ficus-umbellata-1&orientation=squarish',
    description: 'ハート型の大きな葉が美しいフィカスの仲間。インテリアツリーとして人気が高く、おしゃれな空間を演出します。',
    difficulty: '初級',
    bloomSeason: '通年（葉を楽しむ）',
    careGuide: {
      light: '明るい場所を好みます。窓際のレースカーテン越しが理想的です。',
      water: '土の表面が乾いたら水を与えます。冬は乾燥気味に管理します。',
      temperature: '15〜25℃が適温。寒さには比較的強いです。',
      humidity: '適度な湿度を保ちます。乾燥する季節は葉水を与えましょう。',
      fertilizer: '春〜秋に月1回、緩効性肥料を与えます。',
      repotting: '2〜3年に1回、春に植え替えを行います。',
      tips: [
        'ハート型の葉が魅力的です',
        '剪定で樹形を整えることができます',
        '比較的育てやすい観葉植物です'
      ],
      warnings: [
        '急激な環境変化で葉が落ちることがあります',
        '水切れに注意してください',
        '樹液に触れるとかぶれることがあります'
      ]
    }
  },
  {
    id: 27,
    name: 'サンスベリア',
    scientificName: 'Sansevieria trifasciata',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20sansevieria%20snake%20plant%20with%20upright%20sword-like%20leaves%2C%20green%20and%20yellow%20striped%20pattern%2C%20modern%20minimalist%20interior%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20air%20purifying%20houseplant&width=300&height=300&seq=sansevieria-1&orientation=squarish',
    description: '剣のような直立した葉が特徴的な多肉質の観葉植物。空気清浄効果があり、非常に丈夫で初心者にもおすすめです。',
    difficulty: '初級',
    bloomSeason: '通年（葉を楽しむ）',
    careGuide: {
      light: '明るい場所から半日陰まで適応します。直射日光でも大丈夫です。',
      water: '乾燥に強く、水やりは控えめに。土が完全に乾いてから与えます。',
      temperature: '15〜30℃で管理。寒さにはやや弱いです。',
      humidity: '乾燥した環境を好みます。過湿は避けてください。',
      fertilizer: '春〜秋に2ヶ月に1回、薄めた液体肥料を与えます。',
      repotting: '2〜3年に1回、春に植え替えを行います。',
      tips: [
        '非常に丈夫で手間がかかりません',
        '空気清浄効果があります',
        '乾燥に強く水やりを忘れても大丈夫'
      ],
      warnings: [
        '水のやりすぎは根腐れの原因になります',
        '冬は水やりをさらに控えめに',
        '葉が重いので倒れないよう注意'
      ]
    }
  },
  {
    id: 28,
    name: 'ポトス',
    scientificName: 'Epipremnum aureum',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20pothos%20houseplant%20with%20heart-shaped%20variegated%20leaves%2C%20trailing%20vine%20in%20hanging%20basket%2C%20green%20and%20yellow%20foliage%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20easy%20care%20indoor%20plant&width=300&height=300&seq=pothos-1&orientation=squarish',
    description: 'ハート型の斑入り葉が美しいつる性の観葉植物。非常に育てやすく、ハンギングバスケットや棚からの垂らし植えに人気です。',
    difficulty: '初級',
    bloomSeason: '通年（葉を楽しむ）',
    careGuide: {
      light: '明るい日陰を好みます。直射日光は葉焼けの原因になります。',
      water: '土の表面が乾いたら水を与えます。冬は控えめに管理します。',
      temperature: '15〜25℃が適温。寒さにはやや弱いです。',
      humidity: '適度な湿度を保ちます。葉水を定期的に与えましょう。',
      fertilizer: '春〜秋に月1回、薄めた液体肥料を与えます。',
      repotting: '1〜2年に1回、春に植え替えを行います。',
      tips: [
        'つるを伸ばして楽しめます',
        '挿し木で簡単に増やせます',
        '水耕栽培でも育てられます'
      ],
      warnings: [
        '直射日光は避けてください',
        '寒さに弱いので冬は注意',
        'ペットが食べると有毒です'
      ]
    }
  },
  {
    id: 29,
    name: 'ドラセナ・マッサンゲアナ',
    scientificName: 'Dracaena massangeana',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20dracaena%20massangeana%20corn%20plant%20with%20yellow%20striped%20leaves%2C%20tall%20indoor%20tree%20in%20modern%20office%20setting%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20elegant%20houseplant%20display&width=300&height=300&seq=dracaena-massangeana-1&orientation=squarish',
    description: '幸福の木として親しまれるドラセナの代表種。黄色い縞模様の入った葉が美しく、贈り物としても人気があります。',
    difficulty: '初級',
    bloomSeason: '通年（葉を楽しむ）',
    careGuide: {
      light: '明るい日陰を好みます。強い直射日光は避けてください。',
      water: '土の表面が乾いたら水を与えます。冬は控えめに管理します。',
      temperature: '18〜28℃が適温。寒さには比較的強いです。',
      humidity: '適度な湿度を保ちます。葉水を定期的に与えましょう。',
      fertilizer: '春〜秋に月1回、緩効性肥料を与えます。',
      repotting: '2〜3年に1回、春に植え替えを行います。',
      tips: [
        '幸福の木として縁起が良いとされています',
        '比較的育てやすい観葉植物です',
        '贈り物としても人気があります'
      ],
      warnings: [
        '葉先が茶色くなったら湿度不足のサイン',
        '水のやりすぎは根腐れの原因になります',
        '急激な環境変化は避けてください'
      ]
    }
  },
  {
    id: 30,
    name: 'アロエ・ベラ',
    scientificName: 'Aloe vera',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20aloe%20vera%20succulent%20plant%20with%20thick%20fleshy%20leaves%2C%20medicinal%20houseplant%20in%20terracotta%20pot%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20healthy%20green%20succulent%20display&width=300&height=300&seq=aloe-vera-1&orientation=squarish',
    description: '薬用植物として有名な多肉植物。肉厚の葉には美容や健康に良い成分が含まれており、観賞用としても人気があります。',
    difficulty: '初級',
    bloomSeason: '通年（葉を楽しむ）',
    careGuide: {
      light: '明るい場所を好みます。直射日光でも大丈夫ですが、夏は半日陰が良いです。',
      water: '乾燥に強く、土が完全に乾いてから水を与えます。冬はさらに控えめに。',
      temperature: '15〜25℃が適温。寒さには弱いので冬は室内で管理します。',
      humidity: '乾燥した環境を好みます。過湿は避けてください。',
      fertilizer: '春〜秋に2ヶ月に1回、薄めた液体肥料を与えます。',
      repotting: '2〜3年に1回、春に植え替えを行います。',
      tips: [
        '葉の中のゲルは美容に使えます',
        '子株で増やせます',
        '非常に丈夫で手間がかかりません'
      ],
      warnings: [
        '水のやりすぎは根腐れの原因になります',
        '寒さに弱いので冬は注意',
        '葉を切る際は清潔な刃物を使用'
      ]
    }
  },
  {
    id: 31,
    name: 'ガジュマル',
    scientificName: 'Ficus microcarpa',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20ficus%20microcarpa%20gajumaru%20bonsai%20tree%20with%20thick%20trunk%20and%20aerial%20roots%2C%20small%20indoor%20tree%20in%20decorative%20pot%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20Japanese%20style%20houseplant&width=300&height=300&seq=gajumaru-1&orientation=squarish',
    description: '沖縄では精霊が宿る木として親しまれているガジュマル。太い幹と気根が特徴的で、盆栽としても人気があります。',
    difficulty: '初級',
    bloomSeason: '通年（葉を楽しむ）',
    careGuide: {
      light: '明るい場所を好みます。直射日光でも半日陰でも育ちます。',
      water: '土の表面が乾いたら水を与えます。冬は控えめに管理します。',
      temperature: '15〜30℃で管理。寒さには比較的強いです。',
      humidity: '適度な湿度を保ちます。葉水を定期的に与えましょう。',
      fertilizer: '春〜秋に月1回、緩効性肥料を与えます。',
      repotting: '1〜2年に1回、春に植え替えを行います。',
      tips: [
        '精霊が宿る縁起の良い木とされています',
        '剪定で樹形を整えることができます',
        '気根が伸びて独特の姿になります'
      ],
      warnings: [
        '成長が早いので定期的な剪定が必要',
        '樹液に触れるとかぶれることがあります',
        '急激な環境変化で葉が落ちることがあります'
      ]
    }
  },

  // 新規追加：ハーブ類
  {
    id: 38,
    name: 'バジル',
    scientificName: 'Ocimum basilicum',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20fresh%20basil%20herb%20plant%20with%20green%20aromatic%20leaves%2C%20culinary%20herb%20in%20pot%2C%20kitchen%20garden%20setting%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20edible%20plant%20display&width=300&height=300&seq=basil-herb-new&orientation=squarish',
    description: 'イタリア料理に欠かせない香り高いハーブ。育てやすく、料理にも使える実用的な植物です。',
    difficulty: '初級',
    bloomSeason: '夏',
    careGuide: {
      light: '日当たりの良い場所を好みます。室内なら窓際が最適です。',
      water: '土の表面が乾いたら水を与えます。乾燥に弱いので注意。',
      temperature: '20〜30℃が適温。寒さには弱いです。',
      humidity: '適度な湿度を保ちます。',
      fertilizer: '月1回、薄めた液体肥料を与えます。',
      repotting: '年1回、春に植え替えを行います。',
      tips: [
        '摘心すると枝分かれして収穫量が増えます',
        '花が咲く前に収穫すると香りが良いです',
        '料理に使えて実用的です'
      ],
      warnings: [
        '寒さに非常に弱いです',
        '水切れに注意してください',
        '害虫がつきやすいので注意'
      ]
    }
  },
  {
    id: 39,
    name: 'ローズマリー',
    scientificName: 'Rosmarinus officinalis',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20rosemary%20herb%20plant%20with%20needle-like%20aromatic%20leaves%2C%20Mediterranean%20culinary%20herb%2C%20kitchen%20garden%20setting%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20fragrant%20plant%20display&width=300&height=300&seq=rosemary-herb-new&orientation=squarish',
    description: '針のような葉が特徴的な地中海原産のハーブ。爽やかな香りで料理や香りを楽しめます。',
    difficulty: '初級',
    bloomSeason: '春〜夏',
    careGuide: {
      light: '日当たりの良い場所を好みます。十分な日光が必要です。',
      water: '乾燥気味に管理します。過湿は避けてください。',
      temperature: '10〜25℃で管理。寒さには比較的強いです。',
      humidity: '乾燥した環境を好みます。',
      fertilizer: '春と秋に緩効性肥料を少量与えます。',
      repotting: '2〜3年に1回、春に植え替えを行います。',
      tips: [
        '乾燥を好むので水やりは控えめに',
        '剪定で樹形を整えることができます',
        '料理や香りを楽しめます'
      ],
      warnings: [
        '過湿は根腐れの原因になります',
        '冬は水やりをさらに控えめに',
        '成長が遅いので気長に育てましょう'
      ]
    }
  },
  {
    id: 40,
    name: 'ミント',
    scientificName: 'Mentha',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20mint%20herb%20plant%20with%20fresh%20green%20aromatic%20leaves%2C%20refreshing%20culinary%20herb%20in%20pot%2C%20kitchen%20garden%20setting%2C%20soft%20natural%20lighting%2C%20detailed%20botanical%20photography%2C%20fragrant%20edible%20plant&width=300&height=300&seq=mint-herb-new&orientation=squarish',
    description: '爽やかな香りが特徴的なハーブ。成長が早く、ハーブティーや料理に使える人気の植物です。',
    difficulty: '初級',
    bloomSeason: '夏',
    careGuide: {
      light: '半日陰を好みます。強い直射日光は避けてください。',
      water: '水を好む植物です。土が乾かないよう注意してください。',
      temperature: '15〜25℃が適温。寒さには比較的強いです。',
      humidity: '適度な湿度を保ちます。',
      fertilizer: '月1回、薄めた液体肥料を与えます。',
      repotting: '年1回、春に植え替えを行います。',
      tips: [
        '成長が非常に早いです',
        'ハーブティーや料理に使えます',
        '挿し木で簡単に増やせます'
      ],
      warnings: [
        '成長が早いので定期的な剪定が必要',
        '水切れに注意してください',
        '地植えすると広がりすぎるので鉢植えがおすすめ'
      ]
    }
  },

  // 新規追加：多肉植物
  {
    id: 41,
    name: 'ハオルチア',
    scientificName: 'Haworthia cooperi',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20haworthia%20succulent%20plant%20with%20translucent%20window%20leaves%2C%20small%20compact%20rosette%20form%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting%2C%20minimalist%20succulent%20display&width=300&height=300&seq=haworthia-new&orientation=squarish',
    description: '透明感のある葉が美しい小型の多肉植物。窓のような葉が特徴的で、コレクターに人気です。',
    difficulty: '初級',
    bloomSeason: '春〜夏',
    careGuide: {
      light: '明るい日陰を好みます。強い直射日光は避けてください。',
      water: '乾燥気味に管理します。土が完全に乾いてから水を与えます。',
      temperature: '10〜25℃で管理。寒さにはやや弱いです。',
      humidity: '乾燥した環境を好みます。',
      fertilizer: '春と秋に月1回、薄めた液体肥料を与えます。',
      repotting: '2〜3年に1回、春に植え替えを行います。',
      tips: [
        '透明感のある葉が美しいです',
        'コンパクトで場所を取りません',
        '子株で増やせます'
      ],
      warnings: [
        '水のやりすぎは根腐れの原因になります',
        '強い日光は葉焼けの原因になります',
        '冬は水やりをさらに控えめに'
      ]
    }
  },
  {
    id: 42,
    name: 'セダム',
    scientificName: 'Sedum morganianum',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20sedum%20burrito%20succulent%20plant%20with%20trailing%20stems%20and%20plump%20leaves%2C%20hanging%20basket%20display%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting%2C%20cascading%20succulent%20arrangement&width=300&height=300&seq=sedum-new&orientation=squarish',
    description: 'ぷっくりとした葉が連なる垂れ下がるタイプの多肉植物。ハンギングバスケットに最適です。',
    difficulty: '初級',
    bloomSeason: '春〜夏',
    careGuide: {
      light: '明るい場所を好みます。室内なら窓際が最適です。',
      water: '乾燥気味に管理します。土が完全に乾いてから水を与えます。',
      temperature: '10〜25℃で管理。寒さにはやや弱いです。',
      humidity: '乾燥した環境を好みます。',
      fertilizer: '春と秋に月1回、薄めた液体肥料を与えます。',
      repotting: '2〜3年に1回、春に植え替えを行います。',
      tips: [
        'ハンギングバスケットに最適です',
        '葉が取れやすいので取り扱いに注意',
        '挿し木で簡単に増やせます'
      ],
      warnings: [
        '水のやりすぎは根腐れの原因になります',
        '葉が取れやすいので慎重に扱ってください',
        '冬は水やりをさらに控えめに'
      ]
    }
  },
  {
    id: 43,
    name: 'カランコエ',
    scientificName: 'Kalanchoe blossfeldiana',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20kalanchoe%20flowering%20succulent%20with%20colorful%20blooms%2C%20compact%20plant%20with%20thick%20leaves%20and%20bright%20flowers%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting%2C%20cheerful%20indoor%20plant%20display&width=300&height=300&seq=kalanchoe-new&orientation=squarish',
    description: '色鮮やかな花を咲かせる多肉植物。長期間花を楽しめる人気の鉢花です。',
    difficulty: '初級',
    bloomSeason: '冬〜春',
    careGuide: {
      light: '明るい場所を好みます。短日処理で花芽ができます。',
      water: '乾燥気味に管理します。土が完全に乾いてから水を与えます。',
      temperature: '15〜25℃が適温。寒さにはやや弱いです。',
      humidity: '適度な湿度を保ちます。',
      fertilizer: '開花期間中は月1回、薄めた液体肥料を与えます。',
      repotting: '年1回、花後に植え替えを行います。',
      tips: [
        '長期間花を楽しめます',
        '短日処理で花芽ができます',
        '比較的育てやすい多肉植物です'
      ],
      warnings: [
        '水のやりすぎは根腐れの原因になります',
        '寒さに弱いので冬は室内で管理',
        '花がらはこまめに摘み取りましょう'
      ]
    }
  },

  // 新規追加：観葉植物
  {
    id: 44,
    name: 'クワズイモ',
    scientificName: 'Alocasia odora',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20alocasia%20odora%20elephant%20ear%20plant%20with%20large%20arrow-shaped%20leaves%2C%20tropical%20foliage%20houseplant%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting%2C%20dramatic%20indoor%20plant%20display&width=300&height=300&seq=alocasia-new&orientation=squarish',
    description: '大きな矢じり型の葉が印象的な観葉植物。トロピカルな雰囲気を演出します。',
    difficulty: '中級',
    bloomSeason: '通年（葉を楽しむ）',
    careGuide: {
      light: '明るい日陰を好みます。直射日光は避けてください。',
      water: '土の表面が乾いたら水を与えます。水を好む植物です。',
      temperature: '20〜30℃が適温。寒さには弱いです。',
      humidity: '高湿度を好みます。葉水を定期的に与えましょう。',
      fertilizer: '春〜秋に月1回、薄めた液体肥料を与えます。',
      repotting: '1〜2年に1回、春に植え替えを行います。',
      tips: [
        '大きな葉が印象的です',
        'トロピカルな雰囲気を演出します',
        '湿度を好むので葉水が重要です'
      ],
      warnings: [
        '寒さに非常に弱いです',
        '乾燥すると葉が枯れやすいです',
        '樹液に触れるとかぶれることがあります'
      ]
    }
  },
  {
    id: 45,
    name: 'オリヅルラン',
    scientificName: 'Chlorophytum comosum',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20spider%20plant%20chlorophytum%20with%20striped%20arching%20leaves%20and%20baby%20plantlets%2C%20easy%20care%20houseplant%20in%20hanging%20basket%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting%2C%20air%20purifying%20plant%20display&width=300&height=300&seq=spider-plant-new&orientation=squarish',
    description: '白い縞模様の葉が美しい観葉植物。子株がたくさんできて増やしやすく、空気清浄効果もあります。',
    difficulty: '初級',
    bloomSeason: '通年（葉を楽しむ）',
    careGuide: {
      light: '明るい場所を好みますが、半日陰でも育ちます。',
      water: '土の表面が乾いたら水を与えます。水を好む植物です。',
      temperature: '10〜25℃で管理。寒さには比較的強いです。',
      humidity: '適度な湿度を保ちます。',
      fertilizer: '春〜秋に月1回、薄めた液体肥料を与えます。',
      repotting: '1〜2年に1回、春に植え替えを行います。',
      tips: [
        '子株で簡単に増やせます',
        '空気清浄効果があります',
        '非常に育てやすい観葉植物です'
      ],
      warnings: [
        '葉先が茶色くなったら水やりを調整',
        '直射日光は葉焼けの原因になります',
        '根が張りやすいので定期的な植え替えが必要'
      ]
    }
  },
  {
    id: 46,
    name: 'アイビー',
    scientificName: 'Hedera helix',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20english%20ivy%20hedera%20plant%20with%20trailing%20vines%20and%20lobed%20leaves%2C%20versatile%20houseplant%20in%20hanging%20basket%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting%2C%20cascading%20foliage%20display&width=300&height=300&seq=ivy-new&orientation=squarish',
    description: 'つる性の観葉植物で、ハンギングバスケットや壁面緑化に最適。育てやすく人気があります。',
    difficulty: '初級',
    bloomSeason: '通年（葉を楽しむ）',
    careGuide: {
      light: '明るい日陰を好みます。直射日光は避けてください。',
      water: '土の表面が乾いたら水を与えます。',
      temperature: '10〜25℃で管理。寒さには強いです。',
      humidity: '適度な湿度を保ちます。',
      fertilizer: '春〜秋に月1回、薄めた液体肥料を与えます。',
      repotting: '1〜2年に1回、春に植え替えを行います。',
      tips: [
        'つるを伸ばして楽しめます',
        '挿し木で簡単に増やせます',
        '寒さに強く育てやすいです'
      ],
      warnings: [
        '成長が早いので定期的な剪定が必要',
        '葉に水滴が残らないよう注意',
        'ペットが食べると有毒です'
      ]
    }
  },
  {
    id: 47,
    name: 'ゴムの木',
    scientificName: 'Ficus elastica',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20rubber%20plant%20ficus%20elastica%20with%20large%20glossy%20dark%20green%20leaves%2C%20tall%20indoor%20tree%20houseplant%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting%2C%20elegant%20foliage%20display&width=300&height=300&seq=rubber-plant-new&orientation=squarish',
    description: '光沢のある大きな葉が美しい観葉植物。丈夫で育てやすく、インテリアグリーンとして人気です。',
    difficulty: '初級',
    bloomSeason: '通年（葉を楽しむ）',
    careGuide: {
      light: '明るい場所を好みます。直射日光でも半日陰でも育ちます。',
      water: '土の表面が乾いたら水を与えます。冬は控えめに。',
      temperature: '15〜25℃が適温。寒さにはやや弱いです。',
      humidity: '適度な湿度を保ちます。葉水を定期的に与えましょう。',
      fertilizer: '春〜秋に月1回、緩効性肥料を与えます。',
      repotting: '2〜3年に1回、春に植え替えを行います。',
      tips: [
        '光沢のある葉が美しいです',
        '剪定で樹形を整えることができます',
        '比較的育てやすい観葉植物です'
      ],
      warnings: [
        '樹液に触れるとかぶれることがあります',
        '急激な環境変化で葉が落ちることがあります',
        '水のやりすぎは根腐れの原因になります'
      ]
    }
  },
  {
    id: 48,
    name: 'コーヒーの木',
    scientificName: 'Coffea arabica',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20coffee%20plant%20coffea%20arabica%20with%20glossy%20green%20leaves%2C%20tropical%20houseplant%20in%20pot%2C%20detailed%20botanical%20photography%2C%20soft%20natural%20lighting%2C%20elegant%20indoor%20tree%20display&width=300&height=300&seq=coffee-plant-new&orientation=squarish',
    description: 'コーヒー豆がなる観葉植物。光沢のある葉が美しく、白い花も楽しめます。',
    difficulty: '中級',
    bloomSeason: '春〜夏',
    careGuide: {
      light: '明るい日陰を好みます。直射日光は避けてください。',
      water: '土の表面が乾いたら水を与えます。水を好む植物です。',
      temperature: '20〜25℃が適温。寒さには弱いです。',
      humidity: '高湿度を好みます。葉水を定期的に与えましょう。',
      fertilizer: '春〜秋に月1回、薄めた液体肥料を与えます。',
      repotting: '1〜2年に1回、春に植え替えを行います。',
      tips: [
        '白い花が咲くことがあります',
        '実がなることもあります',
        '光沢のある葉が美しいです'
      ],
      warnings: [
        '寒さに弱いので冬は室内で管理',
        '乾燥すると葉が落ちやすいです',
        '湿度管理が重要です'
      ]
    }
  }
];

const categories = [
  { id: 'all', name: 'すべて', icon: 'ri-plant-line' },
  { id: 'orchid', name: '胡蝶蘭', icon: 'ri-leaf-line' },
  { id: 'tillandsia', name: 'チランジア', icon: 'ri-seedling-line' },
  { id: 'cyclamen', name: 'シクラメン', icon: 'ri-flower-line' },
  { id: 'seasonal', name: '季節の花', icon: 'ri-calendar-line' },
  { id: 'bonsai', name: '盆栽', icon: 'ri-tree-line' },
  { id: 'houseplant', name: '観葉植物', icon: 'ri-home-garden-line' }
];

const difficulties = [
  { id: 'all', name: 'すべて', color: 'bg-gray-200' },
  { id: '初級', name: '初級', color: 'bg-green-500' },
  { id: '中級', name: '中級', color: 'bg-yellow-500' },
  { id: '上級', name: '上級', color: 'bg-red-500' }
];

export default function Plants() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedDifficulty, setSelectedDifficulty] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedPlant, setSelectedPlant] = useState<Plant | null>(null);

  const filteredPlants = plantsData.filter(plant => {
    const matchesCategory = selectedCategory === 'all' || plant.category === selectedCategory;
    const matchesDifficulty = selectedDifficulty === 'all' || plant.difficulty === selectedDifficulty;
    const matchesSearch = plant.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         plant.scientificName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         plant.description.toLowerCase().includes(searchTerm.toLowerCase());
    
    return matchesCategory && matchesDifficulty && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-24 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Beautiful%20botanical%20garden%20with%20orchids%2C%20air%20plants%2C%20cyclamen%20flowers%2C%20seasonal%20blooms%20and%20bonsai%20trees%2C%20lush%20green%20foliage%2C%20tropical%20greenhouse%20atmosphere%2C%20detailed%20plant%20collection%2C%20soft%20natural%20lighting%2C%20educational%20botanical%20setting&width=1920&height=600&seq=plants-hero&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            植物図鑑
          </h1>
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            胡蝶蘭、チランジア、シクラメン、季節の花、盆栽の美しい世界を探索しましょう。
            <br />
            それぞれの特徴と育て方を詳しくご紹介します。
          </p>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="py-12 bg-gradient-to-br from-green-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Search Bar */}
            <div className="mb-8">
              <div className="relative max-w-md mx-auto">
                <input
                  type="text"
                  placeholder="植物名で検索..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full px-4 py-3 pl-12 rounded-full border border-gray-200 focus:outline-none focus:ring-2 focus:ring-green-500 text-sm"
                />
                <i className="ri-search-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"></i>
              </div>
            </div>

            {/* Category Filter */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">植物の種類</h3>
              <div className="flex flex-wrap justify-center gap-2">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => setSelectedCategory(category.id)}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                      selectedCategory === category.id
                        ? 'bg-green-500 text-white'
                        : 'bg-white text-gray-700 hover:bg-green-100'
                    }`}
                  >
                    <i className={`${category.icon} mr-2`}></i>
                    {category.name}
                  </button>
                ))}
              </div>
            </div>

            {/* Difficulty Filter */}
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">育てやすさ</h3>
              <div className="flex flex-wrap justify-center gap-3">
                {difficulties.map((difficulty) => (
                  <button
                    key={difficulty.id}
                    onClick={() => setSelectedDifficulty(difficulty.id)}
                    className={`flex items-center px-3 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                      selectedDifficulty === difficulty.id
                        ? 'bg-gray-800 text-white'
                        : 'bg-white text-gray-700 hover:bg-gray-100'
                    }`}
                  >
                    <div className={`w-4 h-4 rounded-full mr-2 ${difficulty.color}`}></div>
                    {difficulty.name}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Plants Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              {filteredPlants.length}種類の植物
            </h2>
            <p className="text-gray-600">美しい植物たちの詳細な情報をご覧ください</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredPlants.map((plant) => (
              <div
                key={plant.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all cursor-pointer group"
                onClick={() => setSelectedPlant(plant)}
              >
                <div className="p-4">
                  <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden shadow-lg group-hover:scale-105 transition-transform">
                    <img
                      src={plant.image}
                      alt={plant.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="text-center">
                    <h3 className="text-lg font-bold text-gray-800 mb-1">{plant.name}</h3>
                    <p className="text-xs text-gray-500 mb-2 italic">{plant.scientificName}</p>
                    <div className="flex justify-center items-center gap-3 mb-3">
                      <span className="text-xs text-gray-600">{plant.bloomSeason}</span>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        plant.difficulty === '初級' ? 'bg-green-100 text-green-800' :
                        plant.difficulty === '中級' ? 'bg-yellow-100 text-yellow-800' :
                        'bg-red-100 text-red-800'
                      }`}>
                        {plant.difficulty}
                      </span>
                    </div>
                    <p className="text-gray-600 text-xs line-clamp-2">{plant.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredPlants.length === 0 && (
            <div className="text-center py-16">
              <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
              <h3 className="text-xl font-semibold text-gray-600 mb-2">該当する植物が見つかりません</h3>
              <p className="text-gray-500">検索条件を変更してお試しください</p>
            </div>
          )}
        </div>
      </section>

      {/* Plant Detail Modal */}
      {selectedPlant && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="relative p-8">
              <button
                onClick={() => setSelectedPlant(null)}
                className="absolute top-4 right-4 bg-gray-100 hover:bg-gray-200 w-10 h-10 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>

              {/* Plant Header */}
              <div className="flex flex-col md:flex-row gap-8 mb-8">
                <div className="w-48 h-48 mx-auto md:mx-0 rounded-full overflow-hidden shadow-lg group-hover:scale-105 transition-transform">
                  <img
                    src={selectedPlant.image}
                    alt={selectedPlant.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 text-center md:text-left">
                  <h2 className="text-3xl font-bold text-gray-800 mb-2">{selectedPlant.name}</h2>
                  <p className="text-gray-500 text-lg mb-4 italic">{selectedPlant.scientificName}</p>
                  <div className="flex flex-wrap justify-center md:justify-start gap-4 mb-4">
                    <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                      開花時期: {selectedPlant.bloomSeason}
                    </div>
                    <div className={`px-3 py-1 rounded-full text-sm font-medium ${
                      selectedPlant.difficulty === '初級' ? 'bg-green-100 text-green-800' :
                      selectedPlant.difficulty === '中級' ? 'bg-yellow-100 text-yellow-800' :
                      'bg-red-100 text-red-800'
                    }`}>
                      育てやすさ: {selectedPlant.difficulty}
                    </div>
                  </div>
                  <p className="text-gray-600 leading-relaxed">{selectedPlant.description}</p>
                </div>
              </div>

              {/* Care Guide */}
              <div className="space-y-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">育て方ガイド</h3>
                
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-2xl p-6">
                    <div className="flex items-center mb-3">
                      <i className="ri-sun-line text-2xl text-yellow-600 mr-3"></i>
                      <h4 className="text-lg font-semibold text-gray-800">光</h4>
                    </div>
                    <p className="text-gray-600">{selectedPlant.careGuide.light}</p>
                  </div>

                  <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-6">
                    <div className="flex items-center mb-3">
                      <i className="ri-drop-line text-2xl text-blue-600 mr-3"></i>
                      <h4 className="text-lg font-semibold text-gray-800">水やり</h4>
                    </div>
                    <p className="text-gray-600">{selectedPlant.careGuide.water}</p>
                  </div>

                  <div className="bg-gradient-to-br from-red-50 to-pink-50 rounded-2xl p-6">
                    <div className="flex items-center mb-3">
                      <i className="ri-temp-hot-line text-2xl text-red-600 mr-3"></i>
                      <h4 className="text-lg font-semibold text-gray-800">温度</h4>
                    </div>
                    <p className="text-gray-600">{selectedPlant.careGuide.temperature}</p>
                  </div>

                  <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6">
                    <div className="flex items-center mb-3">
                      <i className="ri-mist-line text-2xl text-green-600 mr-3"></i>
                      <h4 className="text-lg font-semibold text-gray-800">湿度</h4>
                    </div>
                    <p className="text-gray-600">{selectedPlant.careGuide.humidity}</p>
                  </div>

                  <div className="bg-gradient-to-br from-purple-50 to-violet-50 rounded-2xl p-6">
                    <div className="flex items-center mb-3">
                      <i className="ri-flask-line text-2xl text-purple-600 mr-3"></i>
                      <h4 className="text-lg font-semibold text-gray-800">肥料</h4>
                    </div>
                    <p className="text-gray-600">{selectedPlant.careGuide.fertilizer}</p>
                  </div>

                  <div className="bg-gradient-to-br from-gray-50 to-slate-50 rounded-2xl p-6">
                    <div className="flex items-center mb-3">
                      <i className="ri-plant-line text-2xl text-gray-600 mr-3"></i>
                      <h4 className="text-lg font-semibold text-gray-800">植え替え</h4>
                    </div>
                    <p className="text-gray-600">{selectedPlant.careGuide.repotting}</p>
                  </div>
                </div>

                {/* Tips */}
                <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-2xl p-6">
                  <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                    <i className="ri-lightbulb-line text-2xl text-green-600 mr-3"></i>
                    育て方のコツ
                  </h4>
                  <ul className="space-y-2">
                    {selectedPlant.careGuide.tips.map((tip, index) => (
                      <li key={index} className="flex items-start">
                        <i className="ri-check-line text-green-600 mr-2 mt-1"></i>
                        <span className="text-gray-600">{tip}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Warnings */}
                <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-6">
                  <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                    <i className="ri-alert-line text-2xl text-red-600 mr-3"></i>
                    注意事項
                  </h4>
                  <ul className="space-y-2">
                    {selectedPlant.careGuide.warnings.map((warning, index) => (
                      <li key={index} className="flex items-start">
                        <i className="ri-close-line text-red-600 mr-2 mt-1"></i>
                        <span className="text-gray-600">{warning}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Tips Section */}
      <section className="py-16 bg-gradient-to-br from-green-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">植物栽培の基本</h2>
            <p className="text-gray-600">成功する植物栽培のためのポイント</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4">
                <i className="ri-eye-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">観察が大切</h3>
              <p className="text-gray-600">植物の状態を毎日観察し、変化に気づくことが健康な成長の秘訣です。</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                <i className="ri-environment-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">環境を整える</h3>
              <p className="text-gray-600">それぞれの植物に適した光、温度、湿度の環境を整えることが重要です。</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                <i className="ri-time-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">継続は力なり</h3>
              <p className="text-gray-600">植物栽培は継続が大切。毎日の小さなケアが美しい花を咲かせます。</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
